import { OtsComponentFull, StandardPartTypes } from '@luminovo/http-client';

export function hasMultipleOrGenericMatches(ipn: OtsComponentFull): boolean {
    return ipn.matches.length > 1 || ipn.matches.some((match) => match.part.type === StandardPartTypes.Generic);
}
